import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { unstable_capitalize } from '@mui/utils';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { createTheme, ThemeProvider }, "@mui/material/Button": Button, "@mui/material/Box": Box, "@mui/material/Stack": Stack, "@mui/utils": { unstable_capitalize }, "@mui/material/Typography": Typography } } });
export default ClientProvider;
